import React, {FC, useCallback, useMemo, useState} from 'react'
import {LoadingState, PeriodType} from '../../../../global'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {UserInterface} from '../../../modules/auth/models/UserModel'
import {Download} from '../../../features'

const REPORT_PDF = process.env.REACT_APP_REPORT_PDF || 'v2/generate-report-pdf'

type PdfButtonType = {
  period: PeriodType
}

const LoadingIndicator = () => (
  <div data-kt-indicator="on">
    <div className="indicator-progress">
      <span className="spinner-border spinner-border-sm align-middle ms-2" />
    </div>
  </div>
)

const PdfButtonDownload: FC<PdfButtonType> = ({period}) => {

  const [loading, setLoading] = useState<LoadingState>('fulfilled')
  const {id} = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserInterface

  const onSubmit = useCallback(async (): Promise<void> => {
    setLoading('pending')
    try {
      await Download({
        api: REPORT_PDF,
        id: `${id}?start=${period.start}&end=${period.end}`,
        fileName: `Rapport ${period.start} ~ ${period.end}`,
        fileExtension: 'pdf',
      })
      setLoading('fulfilled')
    } catch (error: any) {
      setLoading('rejected')
    }
  }, [id, period])

  const buttonClass = useMemo(() => {
    return `btn btn-sm btn-flex fw-bolder btn-light-${
      loading === 'fulfilled' ? 'success' : 'danger'} border-${
      loading === 'fulfilled' ? 'success' : 'danger'} border-1 border-dashed ${
      loading === 'fulfilled' ? '' : 'disabled'
    }`
  }, [loading])

  const isPending = loading === 'pending'

  return (
    <button className={buttonClass}
            onClick={onSubmit}
            type="submit"
            disabled={isPending}
    >
      <i className="bi bi-file-pdf fs-2" />
      <span>Télécharger mon rapport</span>
      {isPending && <LoadingIndicator />}
    </button>
  )
}

export {PdfButtonDownload}